export default __webpack_public_path__ + "static/media/icon-error-white.065005e6.svg";